export default __webpack_public_path__ + "static/media/tituloEN.4645f03a.png";